import * as React from 'react';
import { Link as GatsbyLink } from 'gatsby';

export interface LinkProps {
  children: React.ReactNode;
  href: string;
}

/**
 * Removes any additional `/docs/` prefix that might be added by the MDX Provider
 */
function formatPath(path: string) {
  return path.replace('/docs/', '/');
}

/**
 * A custom link that parses Markdown for on-site vs off-site URLs
 * and formats as a Gatsby link or standard anchor tag.
 */
export const Link = ({ children, href }: LinkProps) => {
  if (href.startsWith('/')) {
    return <GatsbyLink to={formatPath(href)}>{children}</GatsbyLink>;
  }
  const onPage = href.startsWith('#');
  const attributes = !onPage
    ? {
        target: '_blank',
        rel: 'noreferrer',
      }
    : null;

  return (
    <a href={href} {...attributes}>
      {children}
    </a>
  );
};
